import {ApolloClient, gql, NormalizedCacheObject} from "@apollo/client";

import {UserCredits, UserCreditsVariables} from "../types";

// Return how many credits a user has
// Hasura will only allow to ask for the credits of the same user or the owner of the ensembles where we are conductors
export default async function userCredits(
  client: ApolloClient<NormalizedCacheObject>,
  userId: number,
): Promise<number> {
  const response = await client.query<UserCredits, UserCreditsVariables>({
    query: gql`
      query UserCredits($userId: Int!) {
        credits_aggregate(where: {user_id: {_eq: $userId}}) {
          aggregate {
            # eslint-disable-next-line
            sum {
              credits
            }
          }
        }
      }
    `,
    variables: {userId},
  });
  return response.data.credits_aggregate?.aggregate?.sum?.credits || 0;
}
